import { UUID } from "crypto";
import type { UserResponse } from "./user";

export type GroupCreate = {
  name: string;
};

export type GroupOption = { id: UUID; name: string };

// 0=ADMIN, 1=MEMBER, 2=ADMIN_AND_HR ("Agency manager"),
// 3=CONTEXT_EDITOR (member + group AI-context editing, nothing else)
export const GroupMemberRole = {
  ADMIN: 0,
  MEMBER: 1,
  ADMIN_AND_HR: 2,
  CONTEXT_EDITOR: 3,
} as const;

export type GroupMemberRoleValue =
  (typeof GroupMemberRole)[keyof typeof GroupMemberRole];

export type GroupMemberResponse = {
  user_id: UUID;
  group_id: UUID;
  role: GroupMemberRoleValue;
  user_name?: string | null;
  user_email?: string | null;
};

// Group-scoped account creation (HR surface). No password — the server emails a
// set-password link. No company-permission selector — the new account inherits
// the standard member permission.
export type GroupUserCreate = {
  email: string;
  cellphone: string;
  full_name?: string | null;
  language?: string | null;
  // Account and employee are one thing: the server links a new employee to the
  // account. Blank → derived from the name server-side.
  employee_code?: string | null;
};

export type GroupUserCreateResponse = {
  invite_email_sent: boolean;
} & UserResponse;

export type GroupUserRemoveResponse = {
  archived: boolean;
};

export type GroupUserRecoveryResponse = {
  message: string;
};

export type GroupResponse = {
  name: string;
  id: UUID;
  owner_id: UUID;
  owner_name?: string | null;
  // Whether the group's owner is the company owner; used to rank the current
  // owner when deciding who may take ownership.
  owner_is_company_owner?: boolean | null;
  ai_context?: string | null;
  created_at: string;
  updated_at: string;
  members: GroupMemberResponse[];
};

export type AssignChannelRequest = {
  channel_type: "email" | "whatsapp" | "sms";
  channel_id: UUID;
};

export type UpdateMemberRoleRequest = {
  role: GroupMemberRoleValue; // 0=ADMIN, 1=MEMBER, 2=ADMIN_AND_HR, 3=CONTEXT_EDITOR
};
